module.exports = __webpack_public_path__ + "img/cloc.f8e66949.png";